var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-h3 font-sans truncate me-6 flex" },
    [
      _vm._l(_vm.crumbs, function (crumb, index) {
        return _c(
          "div",
          { key: index, staticClass: "items-center flex-shrink-0" },
          [
            index < _vm.crumbs.length - 1
              ? _c(
                  "span",
                  { staticClass: "flex items-center" },
                  [
                    _vm.navigationDisabled(crumb)
                      ? _c("span", [_vm._v(_vm._s(crumb.text))])
                      : _c("router-link", {
                          attrs: { to: crumb.to, append: true, custom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ navigate, href }) {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: href },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return navigate(href)
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(crumb.text) + " ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                    _c("svg-icon", {
                      staticClass: "icon-md mx-3 flip-icon-if-rtl",
                      attrs: { name: "chevron-right" },
                    }),
                  ],
                  1
                )
              : _c("span", [_vm._v(_vm._s(crumb.text))]),
          ]
        )
      }),
      _vm.showNewBadge
        ? _c("new-feature-badge", { staticClass: "ms-4" })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }